import { useAtomValue } from 'jotai'
import { useMemo } from 'react'
import useSmartAccount from 'src/common/api-clients/safe-protocol-kit/useSmartAccount'
import useOwnedCarbonTokens from 'src/common/apollo/hooks/useOwnedCarbonTokens'
import useCarbonBundle from 'src/common/contracts/hooks/carbon-bundles/useCarbonBundle'
import { OwnedNFT } from 'src/common/types/models/Tokens'
import { viccCountAtom } from '../../bundle-store'

const useCarbonBundleDepositTx = () => {
  const { smartAccountInfo } = useSmartAccount()
  const { ownedCarbonTokens } = useOwnedCarbonTokens(smartAccountInfo?.address)

  const viccCount = useAtomValue(viccCountAtom)

  const depositedCarbonNfts = useMemo(() => {
    return ownedCarbonTokens ? ownedCarbonTokens.slice(0, viccCount) : []
  }, [ownedCarbonTokens, viccCount])

  const { depositNewAssets } = useCarbonBundle()

  const depositTx = useMemo(() => {
    return depositNewAssets(depositedCarbonNfts as OwnedNFT[])
  }, [depositNewAssets, depositedCarbonNfts])

  return {
    depositTx,
  }
}

export default useCarbonBundleDepositTx
